<div class="info-page">
  <h3>{{ actionLabel }} Ação</h3>
</div>

<form [formGroup]="form" (ngSubmit)="salvar()">
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Ação</label>
      <textarea id="title" class="form-control" rows="3" formControlName="title" placeholder="Título da Ação" maxlength="255"></textarea>
      <app-field-message [field]="fieldMessageRequired('title')" [erros]="fieldErros('title')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Descrição</label>
      <textarea id="description" class="form-control" rows="3" formControlName="description" placeholder="Descrição da Ação" maxlength="400"></textarea>
      <app-field-message [field]="fieldMessageRequired('description')" [erros]="fieldErros('description')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Responsável titular</label>
      <ng-select id="manager" class="ng-select-alternative" [items]="listUsuario" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="manager">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('manager')" [erros]="fieldErros('manager')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Responsável adjunto</label>
      <ng-select id="adjunct" class="ng-select-alternative" [multiple]="true" [items]="listUsuario" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="adjunct">
      </ng-select>
    </div>
  </div>

  <!-- Table -->
  <div class="form-group row m-b">
    <div class="col-12 col-sm-10">
      <label class="col-sm-12 pb-1">Medida Física</label>
      <div class="system-table table-container system-table-m-b table-form">
        <div class="system-table-conteiner system-table-form-conteiner system-table-select">
          <table>
            <thead>
              <tr>
                <th>Título</th>
                <th>Unid. med.</th>
                <th>Casas decimais</th>
                <th>Meta</th>
                <th class="text-center"></th>
              </tr>
            </thead>
            <tbody formArrayName="extras">
              <tr *ngFor="let item of getFormArray().controls; let i = index" [formGroupName]="i">
                <td class="text-left">
                  <input type="text" class="form-control" formControlName="title">
                  <app-field-message [field]="fieldMessageRequireds('title', i)" [erros]="fieldErrosFormArray('title', i)"></app-field-message>
                </td>
                <td class="text-left">
                  <ng-select class="ng-select-alternative" [items]="list?.units" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="unit_id">
                  </ng-select>
                  <app-field-message [field]="fieldMessageRequireds('unit_id', i)" [erros]="fieldErrosFormArray('unit_id', i)"></app-field-message>
                </td>
                <td class="text-left">
                  <ng-select class="ng-select-alternative" [items]="list?.decimal_places" (change)="formatarMedidaFisica(i)" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="decimal_places">
                  </ng-select>
                  <app-field-message [field]="fieldMessageRequireds('decimal_places', i)" [erros]="fieldErrosFormArray('decimal_places', i)"></app-field-message>
                </td>
                <td class="text-right">
                  <input type="text" class="form-control text-right" formControlName="goal" (keyup)="formatarMedidaFisica(i)">
                </td>
                <td>
                  <div class="btn-icon">
                    <span class="icon-table icon-red" (click)="removeMedida(i)">
                      <img src="assets/images/svgs/trash.svg" alt="Remover item" tooltip="Remover item" placement="bottom">
                    </span>
                  </div>
                </td>
              </tr>
              <tr *ngIf="getFormArray().controls.length == 0" class="border-b-radius">
                <td colspan="5" class="text-center"> Nenhuma Medida Física</td>
              </tr>
            </tbody>
          </table>
        </div>
        <button class="btn btn-success btn-add-question mb-0" type="button" (click)="addMedida()">Nova Medida Física</button>
      </div>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Status</label>
      <ng-select id="status" class="ng-select-alternative" [items]="list?.status" bindLabel="label" bindValue="id" placeholder="Selecione" [formControlName]="typeStatusForm()">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired(typeStatusForm())" [erros]="fieldErros(typeStatusForm())"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">{{form.get(typeStatusForm()).value != 1 ? 'Início' : 'Início planejado'}}</label>
      <input id="dt_start" class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="dt_start" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" placeholder="dd/mm/aaaa" (change)="dataMask($event, 'dt_start')">
      <app-field-message [field]="fieldMessageRequired('dt_start')" [erros]="fieldErros('dt_start')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">{{form.get(typeStatusForm()).value | formatStatusAndamento}}</label>
      <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="deadline" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" placeholder="dd/mm/aaaa" (change)="dataMask($event, 'deadline')" [ngClass]="{'ng-invalid': dataFinal}">
      <app-field-message [field]="fieldMessageRequired('deadline') || dataFinal" [erros]="fieldErros('deadline')" [textErroServer]="dataFinal"></app-field-message>
    </div>
  </div>

  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-danger m-r-xxl" *ngIf="this.entity?.id" (click)="confirmExcluir()" type="button">Excluir</button>
      <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      <button class="btn btn-primary" type="submit">Salvar</button>
    </div>
  </div>
</form>
<br>
<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
<app-loading [loader]="isLoading"></app-loading>